module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-wrench font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Manutenção do Sistema")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Consistência de estágios dos parques")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Compara o estágio cadastrado do parque com o estágio calculado a partir das\n          datas das Informações Gerais. A sincronização atualiza o cadastro com base nessas datas.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.parkStagesLoading
    },
    on: {
      "click": _vm.runAudit
    }
  }, [_vm._v("\n            Auditar (somente leitura)  \n            "), (_vm.parkStagesLoading && _vm.parkStagesAction === 'audit') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.parkStagesLoading
    },
    on: {
      "click": _vm.runSync
    }
  }, [_vm._v("\n            Sincronizar estágios  \n            "), (_vm.parkStagesLoading && _vm.parkStagesAction === 'sync') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.parkStagesError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.parkStagesError))]) : _vm._e(), _vm._v(" "), (_vm.parkStagesResult) ? _c('div', {
    staticClass: "result-box"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.fixApplied ? 'Sincronização executada.' : 'Auditoria executada.'))]), _vm._v("\n            Total de inconsistências: "), _c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.total))]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('span', [_vm._v(" — Corrigidas: "), _c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.fixed))])]) : _vm._e()]), _vm._v(" "), (_vm.parkStagesResult.inconsistencies.length) ? _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Parque")]), _vm._v(" "), _c('th', [_vm._v("Problemas")]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('th', [_vm._v("Corrigido")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.parkStagesResult.inconsistencies), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "issues-list"
    }, _vm._l((item.issues), function(issue, index) {
      return _c('li', {
        key: index
      }, [_vm._v(_vm._s(issue))])
    }), 0)]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('td', [_c('span', {
      class: item.fixed ? 'label label-success' : 'label label-default'
    }, [_vm._v("\n                    " + _vm._s(item.fixed ? 'Sim' : 'Não') + "\n                  ")])]) : _vm._e()])
  }), 0)]) : _c('p', {
    staticClass: "text-success"
  }, [_vm._v("Nenhuma inconsistência encontrada.")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Natureza jurídica da entidade gestora")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Atualiza as opções dos campos de natureza jurídica (administrativa e financeira)\n          no banco de dados, incluindo a opção "), _c('strong', [_vm._v("Empresa Pública")]), _vm._v(".\n          Equivalente ao comando "), _c('code', [_vm._v("inovadata:update-management-entity-legal-nature-options")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.legalNatureLoading
    },
    on: {
      "click": _vm.runLegalNatureUpdate
    }
  }, [_vm._v("\n            Atualizar opções no banco  \n            "), (_vm.legalNatureLoading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.legalNatureError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.legalNatureError))]) : _vm._e(), _vm._v(" "), (_vm.legalNatureResult) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n          " + _vm._s(_vm.legalNatureResult.message) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Áreas de terreno e edificações (por parque)")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Recria as respostas de áreas de terreno e edificações no questionário do parque\n          a partir das Informações Gerais, quando estiverem inconsistentes.\n          Equivalente ao comando "), _c('code', [_vm._v("inovadata:fix-park-land-areas {parkId}")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-inline btn-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "parkIdInput"
    }
  }, [_vm._v("ID do parque")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.parkId),
      expression: "parkId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control park-id-input",
    attrs: {
      "id": "parkIdInput",
      "type": "number",
      "min": "1",
      "placeholder": "Ex.: 73"
    },
    domProps: {
      "value": (_vm.parkId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parkId = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.landAreasLoading || !_vm.parkId
    },
    on: {
      "click": _vm.runLandAreasFix
    }
  }, [_vm._v("\n            Corrigir áreas do parque  \n            "), (_vm.landAreasLoading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.landAreasError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.landAreasError))]) : _vm._e(), _vm._v(" "), (_vm.landAreasResult) ? _c('div', {
    class: _vm.landAreasResult.status === 'ok' ? 'alert alert-success' : 'alert alert-warning'
  }, [_vm._v("\n          " + _vm._s(_vm.landAreasResult.message) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Outliers financeiros (correção de respostas)")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Compara e corrige valores monetários do Park Quiz com base na planilha de ajustes\n          empacotada na API. Isso "), _c('strong', [_vm._v("atualiza o banco")]), _vm._v(" ("), _c('code', [_vm._v("abstract_field_answer")]), _vm._v(").\n          Não altera o "), _c('code', [_vm._v("KnownFinancialOutlierRegistry")]), _vm._v(", que apenas exclui outliers\n          conhecidos (Biopark, BIOTIC, Órion) no relatório estatístico.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox btn-row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialIncludeUnanswered),
      expression: "financialIncludeUnanswered"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.financialIncludeUnanswered) ? _vm._i(_vm.financialIncludeUnanswered, null) > -1 : (_vm.financialIncludeUnanswered)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.financialIncludeUnanswered,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.financialIncludeUnanswered = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.financialIncludeUnanswered = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.financialIncludeUnanswered = $$c
        }
      }
    }
  }), _vm._v("\n            Incluir quizzes "), _c('code', [_vm._v("unanswered")]), _vm._v(" (ex.: Itaipu 2020)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.financialLoading
    },
    on: {
      "click": _vm.runFinancialAudit
    }
  }, [_vm._v("\n            Auditar (somente leitura)  \n            "), (_vm.financialLoading && _vm.financialAction === 'audit') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.financialLoading
    },
    on: {
      "click": _vm.runFinancialFix
    }
  }, [_vm._v("\n            Corrigir outliers  \n            "), (_vm.financialLoading && _vm.financialAction === 'fix') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.financialError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.financialError))]) : _vm._e(), _vm._v(" "), (_vm.financialResult) ? _c('div', {
    staticClass: "result-box"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.financialResult.fixApplied ? 'Correção executada.' : 'Auditoria executada.'))]), _vm._v("\n            Total: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.total))]), _vm._v(" "), (!_vm.financialResult.fixApplied) ? _c('span', [_vm._v("\n              — A atualizar: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.wouldUpdate))])]) : _c('span', [_vm._v("\n              — Atualizados: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.updated))])]), _vm._v("\n            — Sem alteração: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.unchanged))]), _vm._v("\n            — Não encontrados: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.answerNotFound))]), _vm._v(" "), (_vm.financialResult.parkNotFound) ? _c('span', [_vm._v("\n              — Parque não encontrado: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.parkNotFound))])]) : _vm._e(), _vm._v(" "), (_vm.financialResult.ambiguous) ? _c('span', [_vm._v("\n              — Ambíguos: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.ambiguous))])]) : _vm._e()]), _vm._v(" "), (_vm.financialVisibleRows.length) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Parque")]), _vm._v(" "), _c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Campo")]), _vm._v(" "), _c('th', [_vm._v("Atual")]), _vm._v(" "), _c('th', [_vm._v("Esperado")]), _vm._v(" "), _c('th', [_vm._v("Delta")]), _vm._v(" "), _c('th', [_vm._v("Quiz")]), _vm._v(" "), _c('th', [_vm._v("Detalhe")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.financialVisibleRows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', {
      staticClass: "label",
      class: _vm.financialStatusClass(row.status)
    }, [_vm._v(_vm._s(row.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.parkLabel || row.parkNameContains))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.fieldLabel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.currentValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.expectedValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.delta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quizStatus || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.detail))])])
  }), 0)]), _vm._v(" "), (_vm.financialHiddenUnchanged > 0) ? _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n              " + _vm._s(_vm.financialHiddenUnchanged) + " linha(s) "), _c('code', [_vm._v("unchanged")]), _vm._v("/"), _c('code', [_vm._v("skipped_pending")]), _vm._v(" ocultas.\n            ")]) : _vm._e()]) : _c('p', {
    staticClass: "text-success"
  }, [_vm._v("Nenhuma linha com delta ou problema a reportar.")])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca6df316","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/maintenance/ParkStageAudit.vue
// module id = 769
// module chunks = 1